import project01 from './project-01';
import project02 from './project-02';
import project03 from './project-03';

export const projects = [project01, project02, project03];

export const getProjectById = (id) =>
  projects.find((project) => String(project.id) === String(id));

export const getProjectBySlug = (slug) =>
  projects.find((project) => project.slug === slug);
